import { render, staticRenderFns } from "./NoticeTab.vue?vue&type=template&id=94aad776&scoped=true&"
import script from "./NoticeTab.vue?vue&type=script&lang=js&"
export * from "./NoticeTab.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTab.vue?vue&type=style&index=0&id=94aad776&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aad776",
  null
  
)

export default component.exports